// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
 * Design base: 1536px width x 864px height
 * All values converted to percentages/viewport units for responsiveness
 */

/* Page container - no scroll, full viewport */
.register-page_pageContainer__4NtXC {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  background:
    linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),
    conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);
}

/* First page image - register0 (bottom right)
 * Base dimensions for 1536x864 screen:
 * width: 770px, height: 614px
 * top: 601px, left: 1010px
 */
.register-page_Register0__8ioPZ {
  position: absolute;
  /* 770/1536 ≈ 50.13vw for width */
  width: 29vw;
  /* 614/864 ≈ 71.06vh for height - using auto for aspect ratio */
  height: auto;
  /* 601/864 ≈ 69.56% for top */
  bottom: 0%;
  /* 1010/1536 ≈ 65.76% for left */
  right: 0%;
  opacity: 1;
  pointer-events: none;
  /* Above background but behind inputs */
  z-index: 0;
}

/* Second page image - register1 (bottom left) */
.register-page_Register1__nWVVg {
  position: absolute;
  width: 45vw;
  height: auto;
  /* Shifted right to be more visible on desktop */
  bottom: 0%;
  left: 0%;
  transform: rotate(0.97deg);
  opacity: 1;
  pointer-events: none;
  z-index: 0;
}

/* Second page image - register2 (top right) */
.register-page_Register2__yFV7r {
  position: absolute;
  width: 45vw;
  height: auto;
  /* Shifted down and left to be visible */
  top: -5%;
  left: 59%;
  transform: rotate(-10.43deg);
  opacity: 1;
  pointer-events: none;
  z-index: 0;
}

/* Tablet adjustments */
@media (max-width: 1024px) {
  .register-page_Register0__8ioPZ {
    width: 55vw;
    bottom: 0;
    right: 0;
  }

  .register-page_Register1__nWVVg {
    width: 55vw;
    bottom: 0%;
    left: -10%
  }

  .register-page_Register2__yFV7r {
    width: 55vw;
    top: 0%;
    left: 50%;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .register-page_Register0__8ioPZ {
    width: 60vw;
    top: auto;
    bottom: -3%;
    right: 0%;
  }

  .register-page_Register1__nWVVg {
    width: 70vw;
    top: auto;
    bottom: -5%;
    left: -5%;
  }

  .register-page_Register2__yFV7r {
    width: 70vw;
    top: -5%;
    left: 40%;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/auth/pages/register-page.module.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,8CAA8C;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB;;qKAEmK;AACrK;;AAEA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,+DAA+D;EAC/D,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,gCAAgC;EAChC,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,uCAAuC;EACvC,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,UAAU;EACV,QAAQ;EACR,0BAA0B;EAC1B,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,SAAS;IACT,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,UAAU;IACV;EACF;;EAEA;IACE,WAAW;IACX,OAAO;IACP,SAAS;EACX;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,WAAW;IACX,SAAS;IACT,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,SAAS;IACT,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;EACX;AACF","sourcesContent":["/* \n * Design base: 1536px width x 864px height\n * All values converted to percentages/viewport units for responsiveness\n */\n\n/* Page container - no scroll, full viewport */\n.pageContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  max-height: 100vh;\n  overflow: hidden;\n  background:\n    linear-gradient(180deg, #000000 15.29%, rgba(0, 0, 0, 0) 100%),\n    conic-gradient(from 34.81deg at 101.94% 101.46%, #475F02 -28.12deg, #4C0700 43.42deg, #533800 144.36deg, #0C2B4F 231.96deg, #475F02 331.88deg, #4C0700 403.42deg);\n}\n\n/* First page image - register0 (bottom right)\n * Base dimensions for 1536x864 screen:\n * width: 770px, height: 614px\n * top: 601px, left: 1010px\n */\n.Register0 {\n  position: absolute;\n  /* 770/1536 ≈ 50.13vw for width */\n  width: 29vw;\n  /* 614/864 ≈ 71.06vh for height - using auto for aspect ratio */\n  height: auto;\n  /* 601/864 ≈ 69.56% for top */\n  bottom: 0%;\n  /* 1010/1536 ≈ 65.76% for left */\n  right: 0%;\n  opacity: 1;\n  pointer-events: none;\n  /* Above background but behind inputs */\n  z-index: 0;\n}\n\n/* Second page image - register1 (bottom left) */\n.Register1 {\n  position: absolute;\n  width: 45vw;\n  height: auto;\n  /* Shifted right to be more visible on desktop */\n  bottom: 0%;\n  left: 0%;\n  transform: rotate(0.97deg);\n  opacity: 1;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Second page image - register2 (top right) */\n.Register2 {\n  position: absolute;\n  width: 45vw;\n  height: auto;\n  /* Shifted down and left to be visible */\n  top: -5%;\n  left: 59%;\n  transform: rotate(-10.43deg);\n  opacity: 1;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Tablet adjustments */\n@media (max-width: 1024px) {\n  .Register0 {\n    width: 55vw;\n    bottom: 0;\n    right: 0;\n  }\n\n  .Register1 {\n    width: 55vw;\n    bottom: 0%;\n    left: -10%\n  }\n\n  .Register2 {\n    width: 55vw;\n    top: 0%;\n    left: 50%;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n  .Register0 {\n    width: 60vw;\n    top: auto;\n    bottom: -3%;\n    right: 0%;\n  }\n\n  .Register1 {\n    width: 70vw;\n    top: auto;\n    bottom: -5%;\n    left: -5%;\n  }\n\n  .Register2 {\n    width: 70vw;\n    top: -5%;\n    left: 40%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `register-page_pageContainer__4NtXC`,
	"Register0": `register-page_Register0__8ioPZ`,
	"Register1": `register-page_Register1__nWVVg`,
	"Register2": `register-page_Register2__yFV7r`
};
export default ___CSS_LOADER_EXPORT___;
